<template>
  <q-card flat bordered class="q-pa-xs">
    <div class="row q-gutter-xs q-pa-xs">
      <q-select
        dense
        outlined
        single
        v-model="selected_fiscal_year"
        :options="FiscalYear"
        label="Fiscal Year"
        class="q-mx-xs ellipsis"
        style="max-width: 150px"
        @update:model-value="loadData()"
      >
        <q-tooltip class="bg-primary text-white">select fiscal year</q-tooltip>
      </q-select>

      <q-select
        dense
        outlined
        single
        v-model="selected_quarter"
        :options="Quarter"
        label="Quarter"
        class="q-mx-xs ellipsis"
        style="max-width: 100px; min-width: 90px"
        @update:model-value="loadData()"
      >
        <q-tooltip class="bg-primary text-white">select quarter</q-tooltip>
      </q-select>
      <q-select
        dense
        outlined
        single
        v-model="selectedSector"
        :options="optionSectors"
        label="Choose sector"
        input-debounce="0"
        option-label="name"
        option-value="symbol"
        class="q-mx-xs ellipsis"
        style="max-width: 150px"
        :menu-absolute="true"
      >
        <q-tooltip class="bg-primary text-white">Select Sector </q-tooltip>
      </q-select>

      <q-checkbox
        v-model="fundamuntalScanSelect.eps"
        color="blue-5"
        keep-color
        label="EPS"
      >
        <q-tooltip class="bg-primary">earning per share</q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-model="fundamuntalScanSelect.net_worth"
        color="blue-5"
        keep-color
        label="Net Worth"
      >
        <q-tooltip class="bg-primary">net worth</q-tooltip>
      </q-checkbox>

      <!-- <q-checkbox
        disable
        v-model="fundamuntalScanSelect.peg_ratio"
        color="blue-5"
        keep-color
        label="PEG Ratio"
      >
        <q-tooltip class="bg-primary">peg ratio</q-tooltip>
      </q-checkbox> -->

      <q-checkbox
        v-model="fundamuntalScanSelect.pe_ratio"
        color="blue-5"
        keep-color
        label="PE Ratio"
      >
        <q-tooltip class="bg-primary">pe ratio</q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-model="fundamuntalScanSelect.pb_ratio"
        color="blue-5"
        keep-color
        label="PB Ratio"
      >
        <q-tooltip class="bg-primary">pb ratio</q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-model="fundamuntalScanSelect.price"
        color="blue-5"
        keep-color
        label="Price"
      >
        <q-tooltip class="bg-primary">Price</q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-model="fundamuntalScanSelect.listed_share"
        color="blue-5"
        keep-color
        label="Listed Shares"
      >
        <q-tooltip class="bg-primary">Listed Shares</q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-model="fundamuntalScanSelect.floated_share"
        color="blue-5"
        keep-color
        label="Floated Shares"
      >
        <q-tooltip class="bg-primary">Floated Shares</q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-model="fundamuntalScanSelect.npl"
        color="blue-5"
        keep-color
        label="NPL"
      >
        <q-tooltip class="bg-primary">Non Performing Loan</q-tooltip>
      </q-checkbox>

      <q-checkbox
        v-model="fundamuntalScanSelect.expired_date"
        color="blue-5"
        keep-color
        label="Expired Date"
      >
        <q-tooltip class="bg-primary">Expired Date</q-tooltip>
      </q-checkbox>
    </div>

    <q-card flat bordered class="row">
      <div
        v-if="fundamuntalScanSelect.eps"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.eps_value1"
                label="Eps"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>

            <div class="col-4 text-center q-pt-sm text-bol">EPS</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>

            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.eps_value2"
                label="Eps"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            EPS between {{ fundamuntalScanSelect?.eps_value1 }} and
            {{ fundamuntalScanSelect?.eps_value2 }}.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.net_worth"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.net_worth_value1"
                label="Net Worth"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              />
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">Net Worth</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.net_worth_value2"
                label="Net Worth"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              />
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            Net Worth between {{ fundamuntalScanSelect?.net_worth_value1 }} and
            {{ fundamuntalScanSelect?.net_worth_value2 }}.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.peg_ratio"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.peg_ratio_value1"
                label="Peg Ratio"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon name="keyboard_arrow_left" size="md" />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">PEG Ratio</div>
            <div class="col-1">
              <q-icon name="keyboard_arrow_right" size="md" />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.peg_ratio_value2"
                label="Peg Ratio"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            PEG Ratio between {{ fundamuntalScanSelect?.peg_ratio_value1 }} and
            {{ fundamuntalScanSelect?.peg_ratio_value2 }}.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.pe_ratio"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.pe_ratio_value1"
                label="Pe Ratio"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">PE Ratio</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.pe_ratio_value2"
                label="Pe Ratio"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            PE Ratio between {{ fundamuntalScanSelect?.pe_ratio_value1 }} and
            {{ fundamuntalScanSelect?.pe_ratio_value2 }}.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.pb_ratio"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.pb_ratio_value1"
                label="Pb Ratio"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">PB Ratio</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.pb_ratio_value2"
                label="Pb Ratio"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            PB Ratio between {{ fundamuntalScanSelect?.pb_ratio_value1 }} and
            {{ fundamuntalScanSelect?.pb_ratio_value2 }}.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.price"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.price_value1"
                label="Price"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">Price</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.price_value2"
                label="Price"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            Price between {{ fundamuntalScanSelect?.price_value1 }} and
            {{ fundamuntalScanSelect?.price_value2 }}.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.listed_share"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.listed_share_value1"
                label="Listed Shares (Lac.)"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">Listed Share</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.listed_share_value2"
                label="Listed Shares(Lac.)"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            Listed Share between
            {{ fundamuntalScanSelect?.listed_share_value1 }} Lac. and
            {{ fundamuntalScanSelect?.listed_share_value2 }} Lac.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.floated_share"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.floated_share_value1"
                label="Floated Shares (Lac.)"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">Floated Share</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.floated_share_value2"
                label="Floated Shares(Lac.)"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            Floated Share between
            {{ fundamuntalScanSelect?.floated_share_value1 }} Lac. and
            {{ fundamuntalScanSelect?.floated_share_value2 }} Lac.
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.npl"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.npl_value1"
                label="NPL"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">NPL</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3">
              <q-input
                dense
                outlined
                v-model="fundamuntalScanSelect.npl_value2"
                label="NPL"
                placeholder="Placeholder"
                type="number"
                class="q-mx-sm"
              >
                <q-tooltip class="bg-primary">Enter Value</q-tooltip>
              </q-input>
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            NPL between
            {{ fundamuntalScanSelect?.npl_value1 }} and
            {{ fundamuntalScanSelect?.npl_value2 }}
          </div>
        </q-card>
      </div>

      <div
        v-if="fundamuntalScanSelect.expired_date"
        class="q-pa-xs"
        :class="widgetWidthPercentage"
      >
        <q-card bordered flat>
          <div dense class="row q-py-xs">
            <div class="col-3 q-px-sm">
              <q-select
                dense
                outlined
                v-model="fundamuntalScanSelect.expired_date_value1"
                :options="[
                  'today',
                  '1 month',
                  '3 month',
                  '6 month',
                  '1 year',
                  '2 year',
                  '3 year',
                  '4 year',
                ]"
                label="Start date"
              />
            </div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_left"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-4 text-center q-pt-sm text-bol">Expired Date</div>
            <div class="col-1">
              <q-icon
                name="keyboard_arrow_right"
                class="text-center"
                size="md"
              />
            </div>
            <div class="col-3 q-px-sm">
              <q-select
                dense
                outlined
                v-model="fundamuntalScanSelect.expired_date_value2"
                :options="[
                  '1 month',
                  '3 month',
                  '6 month',
                  '1 year',
                  '2 year',
                  '3 year',
                  '4 year',
                ]"
                label="Expire date"
              />
            </div>
          </div>
          <q-separator spaced />
          <div class="q-px-sm">
            Expires between
            {{ fundamuntalScanSelect?.expired_date_value1 }} and
            {{ fundamuntalScanSelect?.expired_date_value2 }} from now
          </div>
        </q-card>
      </div>
    </q-card>
  </q-card>
</template>

<script setup>
import { ref, computed, onMounted, watchEffect } from "vue";
import useCore from "src/use/core";
import useUtils from "src/use/utils";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

const props = defineProps({
  widgetWidth: {
    type: String,
  },
  isChart: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["emitData"]);

const $q = useQuasar();
const store = useStore();
const { utilsOptionSectors } = useUtils();
const { allStock, fundamentalScanPro } = useCore();
const fundamentalScanData = ref([]);

const optionSectors = ref(utilsOptionSectors());
const selectedSector = ref(optionSectors.value[0]);

const FiscalYear = ref([
  "082/083",
  "081/082",
  "080/081",
  "079/080",
  "078/079",
  "077/078",
  "076/077",
  "075/076",
  "074/075",
  "074/75",
  "073/074",
]);
const Quarter = ["q1", "q2", "q3", "q4"];

const selected_fiscal_year = ref("081/082");
const selected_quarter = ref("q2");

const loadData = async () => {
  try {
    $q.loading.show({});

    const [allStocksRes, fundamentalScanRes] = await Promise.all([
      allStock(),
      fundamentalScanPro({
        fiscal_year: selected_fiscal_year.value,
        quarter: selected_quarter.value,
      }),
    ]);

    const coreCapitalMap = new Map();
    const publicMap = new Map();

    allStocksRes.data.forEach(({ symbol, core_capital, public_shares }) => {
      coreCapitalMap.set(symbol, core_capital);
      publicMap.set(symbol, public_shares);
    });

    // const coreCapitalMap = new Map(
    //   allStocksRes.data.map((i) => [i.symbol, i.core_capital])
    // );
    // const publicMap = new Map(
    //   allStocksRes.data.map((i) => [i.symbol, i.public_shares])
    // );

    fundamentalScanData.value = fundamentalScanRes.data.map((item) => {
      const listedShare = coreCapitalMap.get(item.symbol);
      const floatedShare = listedShare
        ? (publicMap.get(item.symbol) / 100) * listedShare
        : null;

      return {
        ...item,
        listed_share: listedShare,
        floated_share: floatedShare,
      };
    });
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    $q.loading.hide();
  }
};

const fundamuntalScanSelect = ref({
  eps: true,
  eps_value1: 15,
  eps_value2: 25,
  net_worth: false,
  net_worth_value1: 50,
  net_worth_value2: 200,
  peg_ratio: false,
  peg_ratio_value1: 1,
  peg_ratio_value2: 1,
  pe_ratio: false,
  pe_ratio_value1: 15,
  pe_ratio_value2: 30,
  pb_ratio: false,
  pb_ratio_value1: 1,
  pb_ratio_value2: 3,
  price: false,
  price_value1: 200,
  price_value2: 300,
  listed_share: false,
  listed_share_value1: 1,
  listed_share_value2: 300,
  floated_share: false,
  floated_share_value1: 1,
  floated_share_value2: 300,
  npl: false,
  npl_value1: 1,
  npl_value2: 10,
  expired_date: false,
  expired_date_value1: "today",
  expired_date_value2: "1 year",
});

const getDateRange = (option1, option2) => {
  const today = new Date();
  const startDate = new Date(today);
  const endDate = new Date(today);

  const setIncrement = (date, increment) => {
    if (increment === "today") {
      date;
    } else if (increment === "1 month") {
      date.setMonth(date.getMonth() + 1);
    } else if (increment === "3 month") {
      date.setMonth(date.getMonth() + 3);
    } else if (increment === "6 month") {
      date.setMonth(date.getMonth() + 6);
    } else if (increment === "1 year") {
      date.setFullYear(date.getFullYear() + 1);
    } else if (increment === "2 year") {
      date.setFullYear(date.getFullYear() + 2);
    } else if (increment === "3 year") {
      date.setFullYear(date.getFullYear() + 3);
    } else if (increment === "4 year") {
      date.setFullYear(date.getFullYear() + 4);
    }
  };

  setIncrement(startDate, option1);
  setIncrement(endDate, option2);

  return { startDate, endDate };
};

const finalComputedData = computed(() => {
  const selectedSectorId = selectedSector.value.id;
  return fundamentalScanData.value.filter((item) => {
    const isSectorMatch =
      selectedSectorId === 0 || item.sector_id === selectedSectorId;

    const isEps =
      !fundamuntalScanSelect.value.eps ||
      (fundamuntalScanSelect.value.eps &&
        item.eps > fundamuntalScanSelect.value.eps_value1 &&
        item.eps < fundamuntalScanSelect.value.eps_value2);

    const isNetWorth =
      !fundamuntalScanSelect.value.net_worth ||
      (fundamuntalScanSelect.value.net_worth &&
        item.net_worth > fundamuntalScanSelect.value.net_worth_value1 &&
        item.net_worth < fundamuntalScanSelect.value.net_worth_value2);

    const isPeRatio =
      !fundamuntalScanSelect.value.pe_ratio ||
      (fundamuntalScanSelect.value.pe_ratio &&
        item.pe_ratio > fundamuntalScanSelect.value.pe_ratio_value1 &&
        item.pe_ratio < fundamuntalScanSelect.value.pe_ratio_value2);

    const isPegRatio =
      !fundamuntalScanSelect.value.peg_ratio ||
      (fundamuntalScanSelect.value.peg_ratio &&
        item.peg_ratio > fundamuntalScanSelect.value.peg_ratio_value1 &&
        item.peg_ratio < fundamuntalScanSelect.value.peg_ratio_value2) ||
      !item.peg_ratio;

    const isPbRatio =
      !fundamuntalScanSelect.value.pb_ratio ||
      (fundamuntalScanSelect.value.pb_ratio &&
        item.pb_ratiot_worth > fundamuntalScanSelect.value.pb_ratio_value1 &&
        item.pb_ratiot_worth < fundamuntalScanSelect.value.pb_ratio_value2);

    const isPrice =
      !fundamuntalScanSelect.value.price ||
      (fundamuntalScanSelect.value.price &&
        item.close > fundamuntalScanSelect.value.price_value1 &&
        item.close < fundamuntalScanSelect.value.price_value2);

    const isListedShare =
      !fundamuntalScanSelect.value.listed_share ||
      (fundamuntalScanSelect.value.listed_share &&
        item.listed_share >
          fundamuntalScanSelect.value.listed_share_value1 * 100000 &&
        item.listed_share <
          fundamuntalScanSelect.value.listed_share_value2 * 100000);

    const isFloatedShare =
      !fundamuntalScanSelect.value.floated_share ||
      (fundamuntalScanSelect.value.floated_share &&
        item.floated_share >
          fundamuntalScanSelect.value.floated_share_value1 * 100000 &&
        item.floated_share <
          fundamuntalScanSelect.value.floated_share_value2 * 100000);

    const isNPL =
      !fundamuntalScanSelect.value.npl ||
      (fundamuntalScanSelect.value.npl &&
        item.npl > fundamuntalScanSelect.value.npl_value1 &&
        item.npl < fundamuntalScanSelect.value.npl_value2);

    const { startDate, endDate } = fundamuntalScanSelect.value.expired_date
      ? getDateRange(
          fundamuntalScanSelect.value.expired_date_value1,
          fundamuntalScanSelect.value.expired_date_value2
        )
      : { startDate: null, endDate: null };

    const isExpireDate =
      !fundamuntalScanSelect.value.expired_date ||
      (fundamuntalScanSelect.value.expired_date &&
        new Date(item.expired_date) > startDate &&
        new Date(item.expired_date) < endDate);

    return (
      isSectorMatch &&
      isEps &&
      isNetWorth &&
      isPeRatio &&
      // isPegRatio &&
      isPbRatio &&
      isPrice &&
      isListedShare &&
      isFloatedShare &&
      isNPL &&
      isExpireDate
    );
  });
});

const widgetWidthPercentage = computed(() => {
  if (props.isChart) {
    const widthMap = {
      25: "col-12",
      35: "col-12",
      50: "col-12 col-sm-6 col-md-6",
      60: "col-12 col-sm-6 col-md-4",
    };
    return widthMap[props.widgetWidth] || "col-12 col-sm-4";
  }
  return "col-12 col-sm-4";
});

watchEffect(() => {
  const newVal = finalComputedData.value;
  if (newVal !== undefined) {
    emit("emitData", newVal);
  }
});

function updateSelectedValues() {
  const latestData = store.state.core.latestFiscalYearQuarter[0] || {};
  selected_quarter.value = latestData.quarter ?? "q2";
  selected_fiscal_year.value = latestData.fiscal_year ?? "081/082";
}

onMounted(async () => {
  if (!store.state?.core?.latestFiscalYearQuarter?.length) {
    await store.dispatch("core/latestFiscalYearQuarter");
  }

  updateSelectedValues();
  await loadData();
});
</script>
